import {
  LinearProgress,
  Theme,
  Tooltip,
  Typography,
  useTheme,
  Zoom,
} from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { SupplyChainItem } from '../supplychain-types';

const SupplyChainCoverage: FC<SupplyChainCoverageProps> = ({
  coverage,
  index,
}) => {
  const { classes } = useStyles();
  const theme = useTheme();

  if (index === 0) {
    return (
      <Typography
        key={`coverage-${index}`}
        data-testid={`coverage-${index}`}
        variant='body2'
        color='text.primary'
        height='100%'
        display='flex'
        alignItems='center'
        justifyContent='center'>
        Coverage:
      </Typography>
    );
  }

  if (!coverage) {
    return null;
  }

  const { value, reasons } = coverage;

  return (
    <Zoom in timeout={200 * index} key={`coverage-${index}`}>
      <div className={classes.coverage} data-testid={`coverage-${index}`}>
        <Tooltip
          arrow
          placement='top'
          title={
            reasons?.length ? (
              <div style={{ whiteSpace: 'pre-line' }}>
                {reasons.join(';\r\n')}
              </div>
            ) : (
              ''
            )
          }>
          <div>
            <LinearProgress
              value={value}
              variant='determinate'
              sx={{ minWidth: 60, backgroundColor: theme.palette.divider }}
            />

            <Typography variant='body2' color='text.secondary' mt={1}>
              {value}%
            </Typography>
          </div>
        </Tooltip>
      </div>
    </Zoom>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  coverage: {
    paddingBlockStart: theme.spacing(2),
    '& > div': {
      paddingInline: theme.spacing(2),
    },
  },
}));

interface SupplyChainCoverageProps {
  index: number;
  coverage?: SupplyChainItem['coverage'];
}

export default SupplyChainCoverage;
